export default __webpack_public_path__ + "0ccfd9d5feb938ff92d1a1c492f58c77.png";